<template>
  <div>
    <div class="selectBox">
      <el-form ref="paramsList" :model="params">
        <QS-search maxLine="3">
          <!-- 内容区域-->
          <el-form-item label="车牌号" prop="carId">
            <el-select
              v-model="params.carId"
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="请输入"
              :remote-method="remoteMethod"
              :loading="oLoading.fuzzy"
              @change="carNoChange"
            >
              <el-option
                v-for="item in options"
                :key="'options' + item.id"
                :label="item.plateNo"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="订单ID" prop="orderId">
            <el-input
              v-model="params.orderId"
              clearable
              placeholder="请输入订单ID"
              maxlength="18"
              v-interage="true"
            />
          </el-form-item>
          <el-form-item prop="violationTime" label="违章时间">
            <el-date-picker
              v-model="params.violationTime"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
              @change="violationTimeChange"
            />
          </el-form-item>
          <el-form-item label="违章处理状态" prop="handleState">
              <el-select placeholder="请选择违章处理状态" v-model="params.handleState" clearable>
                <el-option label="全部" value="" />
                <el-option
                  v-for="item in handleStateList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
          </el-form-item>
          <el-form-item label="罚款缴款状态" prop="paymentState">
              <el-select placeholder="请选择罚款缴款状态" v-model="params.paymentState" clearable>
                <el-option label="全部" value="" />
                <el-option
                  v-for="item in paymentStateList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
          </el-form-item>
          <el-form-item label="所属部门" prop="deptIdList">
            <DeptSelect v-model="params.deptIdList" filterable clearable multiple />
          </el-form-item>
          <el-form-item label="处理方式" prop="dealViolationWay">
            <el-select
              v-model="params.dealViolationWay"
              placeholder="请选择处理方式"
              clearable
              filterable
            >
              <el-option
                v-for="item in dealViolationWayList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="最后更新时间" prop="updateViolationTime">
            <QS-date-picker
              v-model="params.updateViolationTime"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="{}"
              clearable
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
          </el-form-item>
           <el-form-item label="备案状态" prop="appearState">
              <el-select placeholder="请选择备案状态" v-model="params.appearState" clearable>
                <el-option label="全部" value="" />
                <el-option
                  v-for="item in appearStateList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
          </el-form-item>
          <!-- 按钮区域，slot方式，各个按钮要单独用item包裹-->
          <template slot="moreBtn">
            <el-form-item>
              <el-button
                :loading="oLoading.search"
                type="primary"
                size="small"
                @click="selectBtn"
              >
                查询
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="small" @click="Reset"> 重置 </el-button>
            </el-form-item>
            <el-form-item v-if="judgePermission('vehicle_violation_record_list_export')">
              <el-button :loading="oLoading.export" @click="asyncExportHandle">
                导出数据
              </el-button>
            </el-form-item>
            <el-form-item v-if="judgePermission('vehicle_violation_record_list_export')">
              <el-button @click="exportDataHandle">
                导出列表
              </el-button>
            </el-form-item>
          </template>
        </QS-search>
      </el-form>
    </div>
    <div class="btn-box">
      <el-button
        type="primary"
        @click="addViolate"
        size="small"
        v-if="judgePermission('vehicle_violation_record_list_create')"
      >新增违章</el-button>
      <el-button
        type="primary"
        @click="batchViolationImport"
        size="small"
        v-if="judgePermission('vehicle_violation_record_list_batch_export')"
      >批量导入违章记录</el-button>
    </div>
    <CarViolationRecordList
      :loading="oLoading"
      :params="params"
      ref="CarViolationRecordList"
    />
    <!-- 新增违章记录 -->
    <AddViolation
      :loading="oLoading"
      v-model="violationShow"
      @refresh="selectBtn"
    />
    <!-- 导入报错弹框 -->
    <dialogWrap
      v-model="uploadDialogShow"
      title="导入失败提示"
      :width="'750px'"
      class="spring-frame"
      :before-close="beforeUploadClose"
    >
      <p
        v-for="(item, index) in uploadTableData"
        :key="index"
        style="margin-bottom: 8px"
      >
        {{ item }}
      </p>
    </dialogWrap>
    <dialog-wrap-upgrade
      ref="batchImport"
      :configOptions="configOptions"
      @close="closeBox"
    >
      <template #uploadMI>
        <el-upload
          class="upload-demo"
          action=""
          :http-request="uploadRequest"
          :limit="1"
          :autoUpload="true"
          :file-list="fileList1"
          :show-file-list="false"
          accept=".xls,.xlsx"
        >
          <el-button size="small" type="primary">导入数据</el-button>
        </el-upload>
      </template>
    </dialog-wrap-upgrade>
    <!-- 导入成功后的提示弹窗 -->
    <dialogWrap
      v-model="isShowTipDialog"
      title="违章信息导入说明"
      :width="'450px'"
      custom-class="dialog-message"
      class="importBox"
    >
      <ul>
        <ol>
          1、本次导入提交完成
        </ol>
        <ol>
          2、点击
          <a @click="jumpPage">违章记录导入历史</a>查看导入进度，同时可在违章记录导入历史中点击【错误详情】查看错误原因，重新上传。
        </ol>
      </ul>
    </dialogWrap>
    <!-- 导出列表 -->
    <export-list-dialog
      v-if="dialogObj.visible"
      :dialogVisible="dialogObj.visible"
      :taskType="7"
      filename="违章记录列表"
      @close="dialogObj.visible = false"
    />
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { FuzzySearch } from '@/api/domain/cars'
import { debounce, getHead } from '@/utils'
import axios from 'axios'
import { violationRecordTemplate } from '@/config'
import { uploadTaskCreate } from '@/api/currencyApi.js'
import selectOption from '@/store/dict/selectOptionDict'
import AddViolation from '../components/addViolation.vue'
import CarViolationRecordList from '../components/carViolationRecordList.vue'
import exportListDialog from '@/pages/orders/overdue/components/exportListDialog.vue'
import { exportViolationDetail } from '@/api/domain/carsService'
import * as Sentry from '@sentry/vue'

export default {
  components: {
    CarViolationRecordList,
    AddViolation,
    exportListDialog,
  },
  data() {
    return {
      isShowTipDialog: false, // 导入成功后的提示弹窗
      uploadDialogShow: false,
      uploadTableData: [],
      violationRecordTemplate,
      oLoading: {
        search: false,
        fuzzy: false,
        del: false,
        export: false,
      },
      params: {
        orderId: '', // 订单ID
        violationTime: '', // 违章时间
        handleState: '', // 违章处理状态
        paymentState: '', // 罚款缴款状态
        appearState: '', // 备案状态
        deptIdList: [], // 所属部门
        dealViolationWay: '',
        updateViolationTime: '',
      },
      violationShow: false, // 新增违章弹框的显隐
      options: [],
      fileList1: [],
      URL: '',
      // 导入功能弹框配置信息
      configOptions: {
        attrs: {
          title: '违章批量维护',
          width: '1000px',
        },
        contentConfig: {
          title:
            '这个功能的前提是，您已经制作了一张目标表单希望直接将Excel转移到系统，若没有制作，请点击下方模板下载按钮',
          describes: [
            '导入前准备：',
            '1.请使用标准模板，确认未进行过任何更改，若无意中修改了模板原有内容，建议重新下载；',
            '2.确保Excel中标题行的名称和表单中与之对应的字段标题一致，且表单中字段名称不能相同；',
            '3.确保Excel中数据没有任何颜色样式，否則将与导入功能的错误提示混淆；',
            '4.确保excel中数据格式正确，比如订单ID为数字，就请不要输入汉宇；',
            '5.如果表单中有设置必填项字段，在Excel中对应的列下，都必须有数据/值；',
            '6.Excel多余的列无法导入，请删除Excel中不需要导入的列；',
            '导入功能说明：',
            '每次请导入全量违章数据，系统会自动对号导入数据进行如下操作：',
            '1、车牌号+违章时间+违章行为没有重复，会默认新增违章信息；',
            '2、车牌号+违章时间+违章行为有重复，会默认更新违章信息;',
          ],
        },
        footerList: [
          { slotName: 'uploadMI' },
          {
            text: '下载模板',
            isShowBtn: true,
            click: () => {
              window.location.href = this.violationRecordTemplate
            },
            options: {
              type: 'primary',
              class: 'ml',
            },
          },
        ],
      },
      dialogObj: { // 弹框相关参数，其他参数根据自身弹框扩展
        visible: false, // 显隐
      },
    }
  },
  computed: {
    handleStateList() {
      return this.dictParseList(selectOption.processingstatusDict)
    },
    paymentStateList() {
      return this.dictParseList(selectOption.paymentStateList)
    },
    appearStateList() {
      return this.dictParseList(selectOption.appearStateDict)
    },
    dealViolationWayList() {
      return this.dictParseList(selectOption.dealViolationWayList)
    },
  },
  mounted() {
    this.URL = this.uploadServiceUrl
    // 车俩id带入默认值直接搜索违章记录
    const { id, carId, plateNo, handleState, orderId, violationTime, deptId } = this.$route.query
    if (plateNo && (id || carId)) {
      this.$set(this.params, 'carId', id || carId)
      this.remoteMethod(plateNo).then((res) => {
        this.$set(this.params, 'carId', res[0].id)
      })
    }
    if (orderId) {
      this.$set(this.params, 'orderId', Number(orderId))
    }
    if (Number(handleState) === 0 || handleState) {
      this.$set(this.params, 'handleState', Number(handleState))
    }
    if (violationTime) {
      this.$set(this.params, 'violationTime', JSON.parse(violationTime))
      this.violationTimeChange(JSON.parse(violationTime))
    }
    if (deptId) {
      this.params.deptIdList = [Number(deptId)]
    }
  },
  methods: {
    // 跳转违章记录页面
    jumpPage() {
      this.$router.push({
        name: 'violationImportHistory',
      })
      this.isShowTipDialog = false
    },
    // 应收时间更改
    violationTimeChange(val) {
      this.params.fromTime = val?.[0] || ''
      this.params.toTime = val?.[1] || ''
    },
    // 批量导入违章维护
    batchViolationImport() {
      this.$refs.batchImport.showDialog()
    },
    // 关闭导入弹窗
    closeBox() {
      this.uploadLoading = false
      this.importDataList = []
    },
    // 导入失败弹窗关闭
    beforeUploadClose() {
      this.uploadTableData = []
      this.uploadDialogShow = false
    },
    /* 自定义上传 */
    uploadRequest({ file }) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('group', 'vehicle')
      formData.append('code', 'vehicle_violation_regulation_file')
      axios({
        url: '/admin/v1/vehicle/fs/standard/upload',
        method: 'POST',
        data: formData,
        headers: {
          ...this.headers,
          ...getHead(this.$store),
        },
        onUploadProgress: ({ loaded, total }) => {
          this.isProgress = true
          this.disabled = true
          this.uploadPercent = parseInt(loaded / total)
        },
      }).then(({ data: { code, data, msg } }) => {
        if (code === 1) {
          try {
            uploadTaskCreate({
              uploadType: 36, // 36 违章记录导入
              fileAddress: data,
              fileName: file.name,
            }).then((res) => {
              const { code: resCode, data: resData } = res
              if (resCode === 1) {
                this.$message({
                  message: '导入成功',
                  type: 'success',
                })
                // 提示弹窗
                this.isShowTipDialog = true
                this.$refs.batchImport.close()
                this.$refs.CarViolationRecordList.paginationEvent()
              } else if (resCode === 23023 && resData && resData.length > 0) {
                this.uploadTableData = resData || []
                this.uploadDialogShow = true
              }
            })
            this.fileList1 = []
          } catch (error) {
            this.fileList1 = []
          }
        } else {
          this.fileList1 = []
          this.$message.error(msg)
        }
      }).catch(() => {
        this.fileList1 = []
      })
    },
    /* 新增违章按钮 */
    addViolate() {
      this.violationShow = !this.violationShow
      if (this.$refs.recordAdd) {
        this.$refs.recordAdd.resetFields()
      }
    },
    /* 查询按钮 */
    selectBtn: debounce(async function () {
      this.params.pageNum = 1
      const searchPara = {
        pagination: {
          pageSize: this.params.pageSize,
          pageNum: 1,
        },
      }
      this.$refs.CarViolationRecordList.paginationEvent(searchPara)
    }, 500),
    /* 重置 */
    Reset() {
      this.params.fromTime = ''
      this.params.toTime = ''
      this.options = []
      this.$refs.paramsList.resetFields()
      this.$refs.CarViolationRecordList.paginationEvent({
        pageSize: this.params.pageSize,
        pageNum: 1,
      })
    },
    /* 车辆模糊搜索 */
    async remoteMethod(query) {
      if (query.length >= 4) {
        this.oLoading.fuzzy = true
        try {
          const { code, data } = await FuzzySearch({
            state: 2,
            plateNo: query,
          })
          this.oLoading.fuzzy = false
          if (code === 1) {
            this.options = data || []
            return data
          }
        } catch (error) {
          this.oLoading.fuzzy = false
        }
      }
    },
    // 车牌号change
    carNoChange(value) {
      if (!value) {
        this.options = []
      }
    },
    // 异步导出数据
    async asyncExportHandle() {
      this.oLoading.export = true
      exportViolationDetail(this.params).then(({ code }) => {
        if (code === 1) {
          this.$message.success('所选数据已生成下载文件，请点击【导出列表】查看下载')
        }
      }).catch((e) => {
        Sentry.captureException(e)
      }).finally(() => {
        this.oLoading.export = false
      })
    },
    // 导出列表
    exportDataHandle() {
      this.dialogObj.visible = true
    },
  },
}
</script>
<style lang="less" scoped>
.el-tabs {
  font-size: 14px;
}
.selectBox {
  margin-bottom: 20px;
  .btnText {
    padding-top: 5px;
    font-size: 14px;
    color: #2e7eff;
  }
}
.btn-box {
  font-size: 0;
  .upload-demo {
    margin: 0 8px;
    display: inline-block;
  }
}
.alertBox1 {
  .el-form-item {
    ::v-deep .el-form-item__label {
      width: 110px;
    }
  }
  .el-input {
    width: 200px;
  }
}
.alertBox2 {
  .el-form-item {
    ::v-deep .el-form-item__label {
      width: 110px;
    }
  }
}
::v-deep .alertBox2 .el-form-item[data-v-f7281b70] .el-form-item__label {
  width: 130px;
}
.cell {
  .btn2 {
    margin-left: 0 !important;
  }
}
.importBox {
  font-size: 14px;
  color: #323233;
  ul,
  ol {
    margin: 0;
    padding: 0;
  }
  header {
    margin-bottom: 8px;
  }
  ul {
    margin-bottom: 16px;
    margin-top: 8px;
  }
  a {
    cursor: pointer;
  }
}
</style>
